import type { BadgeProps } from '@sravni/react-design-system/dist/types/components/Badge';
import { Badge as BaseBadge } from '@sravni/react-design-system/lib/Badge';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Tooltip } from '@sravni/react-design-system/lib/Tooltip';
import { Tip } from '@sravni/react-icons';
import Image from 'next/image';

import styles from './BadgeListItem.module.scss';

export type BadgeListItemProps = BadgeProps & {
  tooltipContent?: string;
  image?: string;
};

export const BadgeListItem = (props: BadgeListItemProps) => {
  const { title: contentText, tooltipContent, image, text, ...otherProps } = props;
  const key = `tooltip_${contentText}_${otherProps.color}_${otherProps.variant}`;
  const badgeText = contentText || text;

  const textElement = image ? (
    <Space
      inline
      align="center"
      size={4}
    >
      <div className={styles.image}>
        <Image
          src={image}
          alt={typeof badgeText === 'string' ? badgeText : contentText}
          unoptimized
          layout="fill"
        />
      </div>
      {badgeText}
    </Space>
  ) : (
    badgeText
  );

  if (tooltipContent) {
    return (
      <Tooltip
        key={key}
        content={tooltipContent}
      >
        <BaseBadge
          {...otherProps}
          title={contentText}
          text={
            <>
              <Icon
                size={16}
                icon={<Tip />}
              />
              {textElement}
            </>
          }
        />
      </Tooltip>
    );
  }

  return (
    <BaseBadge
      key={key}
      {...otherProps}
      text={textElement}
    />
  );
};
